import { type ExtractPropTypes, defineComponent } from 'vue'

import { addUnit, numericProp } from '@xzx-design/utils'
import { useNamespace } from '@xzx-design/hooks'

export const skeletonTitleProps = {
  round: Boolean,
  titleWidth: numericProp,
}

export type SkeletonTitleProps = ExtractPropTypes<typeof skeletonTitleProps>

const name = 'XzxSkeletonTitle'

export default defineComponent({
  name,
  __name: name,
  props: skeletonTitleProps,
  setup(props) {
    const { bem } = useNamespace('skeleton-title')

    return () => (
      <h3
        class={bem([{ round: props.round }])}
        style={{ width: addUnit(props.titleWidth) }}
      />
    )
  },
})
